import {
  effect,
  inject,
  Injectable,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import {
  collection,
  collectionData,
  Firestore,
  query,
  where,
} from '@angular/fire/firestore';
import {
  EventCounter,
  eventCounterConverter,
} from 'src/app/models/eventCounters.model';
import { EventsStoreService } from './events.store.service';

@Injectable({
  providedIn: 'root',
})
export class EventCountersStoreService {
  private firestore = inject(Firestore);
  private _eventStoreService: EventsStoreService = inject(EventsStoreService);
  private _eventCounters: WritableSignal<EventCounter[]> = signal<
    EventCounter[]
  >([]);
  eventCounters: Signal<EventCounter[] | undefined> =
    this._eventCounters.asReadonly();

  constructor() {
    const eventsCollection = collection(
      this.firestore,
      'eventCounters',
    ).withConverter(eventCounterConverter);
    effect(() => {
      const events = this._eventStoreService.events() || [];
      if (events.length === 0) {
        this._eventCounters.set([]);
        return;
      }
      const q = query(
        eventsCollection,
        where(
          'id',
          'in',
          events.map((e) => e.id),
        ),
      );
      collectionData(q, { idField: 'id' }).subscribe((events) => {
        this._eventCounters.set(events);
      });
    });
  }
}
